import React from "react";
import { EnumUpdateRemaindStatus } from "../../../../../server/routes/logUpdated/price/types";
import SelectField from "../../../components/SelectField";
import useFilterValue from "../Provider/hooks/useFilterValue";
import statuses from "../statuses";
import { FieldStatusFC } from "./types";

const FieldStatus: FieldStatusFC = () => {
  const { value, update } = useFilterValue("status");
  const handlerChange = (status: string) => {
    update(
      Object.keys(statuses).indexOf(status) === -1
        ? undefined
        : (status as EnumUpdateRemaindStatus)
    );
  };
  const filteredStatuses = (Object.keys(statuses) as EnumUpdateRemaindStatus[])
      .filter((status) => status !== EnumUpdateRemaindStatus.NULL)
      .map((status) => ({ label: statuses[status].title, value: status }));
  return (
    <SelectField
      size={"small"}
      onChange={handlerChange}
      items={filteredStatuses}
      value={value}
      label={"Статус лога"}
    />
  );
};

export default FieldStatus;
